"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = APIMiddleware;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * @property types {array} api action 的三种类型 - "request, success, error"
 * @property callAPI {function} 调用 API
 * @property shouldCallAPI {function} 是否调用 API，比如有缓存时就不需要再次调用了，return {boolean} 类型
 * @property handleData {function} 处理 success action 的 data
 * @property onRequest {function} 开始请求时回调
 * @property onSuccess {function} 请求成功后回调
 * @property onError {function} 请求失败后回调
 */
function APIMiddleware(_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;

  return function (next) {
    return function (action) {
      var types = action.types,
          callAPI = action.callAPI,
          _action$shouldCallAPI = action.shouldCallAPI,
          shouldCallAPI = _action$shouldCallAPI === undefined ? function () {
        return true;
      } : _action$shouldCallAPI,
          _action$handleData = action.handleData,
          handleData = _action$handleData === undefined ? function (data) {
        return data;
      } : _action$handleData,
          onRequest = action.onRequest,
          onSuccess = action.onSuccess,
          onError = action.onError,
          props = _objectWithoutProperties(action, ["types", "callAPI", "shouldCallAPI", "handleData", "onRequest", "onSuccess", "onError"]);

      // 如果没有 types 参数，那么就不需要此 middleware


      if (!types) return next(action);

      // 如果不需要请求 API，那么直接返回
      if (!shouldCallAPI(getState())) return;

      var _types = _slicedToArray(types, 3),
          requestType = _types[0],
          successType = _types[1],
          errorType = _types[2];

      // dispatch


      dispatch(_extends({}, props, { type: requestType }));
      if (onRequest) onRequest();

      return callAPI().then(function (resp) {
        // 根据 success 属性来判断请求是否成功，使用 message 属性来获取错误信息，如果 API 返回结果不是此格式，请自行转换
        if (!resp.success) {
          dispatch(_extends({}, props, { type: errorType, err: resp.message }));
          if (onError) onError(resp);
          return;
        }

        // 使用 data 属性来获取数据，如果 API 返回结果不是此格式，请自行转换
        dispatch(_extends({}, props, { type: successType, data: handleData(resp.data) }));
        if (onSuccess) onSuccess(getState());
      });
    };
  };
}